export const INTERNAL_API_SYMBOL = Symbol("INTERNAL_API");
